import { getCurrentDensity } from "owa-fabric-densities";
import { changeDensity } from "owa-fabric-theme";
import type DisplayDensityMode from "owa-service/lib/contract/DisplayDensityMode";
import { getUserConfiguration } from "owa-session-store";
import { updateUserConfigurationAndService } from "owa-userconfiguration/lib/utils/updateUserConfigurationAndService";
import type { UserConfigurationArgs } from "owa-graph-schema";

export async function saveDensityOption(displayDensityMode: DisplayDensityMode): Promise<void> {
    const userOptions = getUserConfiguration().UserOptions;
    
    changeDensity(displayDensityMode, getCurrentDensity(displayDensityMode));
    
    const displayDensityChanging = displayDensityMode !== userOptions?.DisplayDensityMode;
    
    if (displayDensityChanging) {
        const updates: UserConfigurationArgs = {};
        if (displayDensityChanging) {
            updates["UserOptions"] = {
                DisplayDensityMode: displayDensityMode,
            };
        }
        await updateUserConfigurationAndService(updates);
    }
}
